import {
  Component,
  Input,
  ViewChild,
  forwardRef,
  OnInit,
  ChangeDetectorRef,
  Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Event } from '@angular/router';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { TranslationService } from '@services/translation.service';
const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EditableTextComponent),
  multi: true,
};

@Component({
    selector: 'app-editable-text',
    templateUrl: './editable-text.component.html',
    providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
    styleUrls: [
        '../../rendered.component.scss',
        './editable-text.component.scss',
    ],
    standalone: false
})
export class EditableTextComponent
  extends BaseScaffoldComponent
  implements ControlValueAccessor, OnInit
{
  @Input() item;
  @Input() data;
  @ViewChild('inlineEditControl') inlineEditControl; // input DOM element
  @Input() type: string = 'text'; // The type of input element
  @Input() required: boolean = false; // Is input requried?
  @Input() disabled: boolean = false; // Is input disabled?
  _value: string = ''; // Private variable for input value
  private preValue: string = ''; // The value before clicking to edit
  editing: boolean = false; // Is Component in edit mode?
  public onChange: any = Function.prototype; // Trascend the onChange event
  public onTouched: any = Function.prototype; // Trascend the onTouch event
  curValue;
  constructor(
    private _renderer: Renderer2,
    public cdb: ChangeDetectorRef,
    public renderedService: RenderedService,
    private translationService: TranslationService
  ) {
    super(cdb, renderedService);
  }
  // Control Value Accessors for ngModel
  get value(): any {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.curValue = v;
      this.onChange(v);
    }
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    //prevent cursor jumping by only updateing the value when not editing it
    this.curValue = value;
    if (!this.editing) {
      this._value = value;
    }
    this.cdb.detectChanges();
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  // Do stuff when the input element loses focus
  onBlur($event: Event) {
    this.editing = false;
    //apply any changes made when editing to the local value to update the static text
    this.value = this.curValue;
    this.cdb.detectChanges();
  }

  //prevent buble up when editing
  inEdit(event) {
    event.stopPropagation();
  }

  // Start the editting process for the input element
  edit(event, value) {
    if (this.checkDisable()) return null;
    event.stopPropagation();
    if (this.disabled) {
      return;
    }

    this.preValue = value;
    this.editing = true;
    // Focus on the input element just as the editing begins
    setTimeout(_ => this.inlineEditControl.nativeElement.focus());
  }

  displayText(value) {
    this.item.label = !this.item?.translation_key_label
      ? this?.item?.label
      : this.translationService.getTranslatedContent(
          this.item?.translation_key_label
        );
    if (this.item?.text_transform) {
      this.item.label = this.translationService.transform(
        this?.item?.label,
        this?.item?.translation_key
      );
    }

    let toReturn = '';
    if (this.item) {
      let elemType = this.item.display_type || 'p';

      if (value) {
        if (value.match(/\<script/)) value = this.stripScripts(value);
        toReturn += '<' + elemType + '>' + value + '</' + elemType + '>';
      } else {
        toReturn +=
          '<' +
          elemType +
          '>' +
          '<span class="text-placeholder">' +
          this.item.label +
          '</span>' +
          '</' +
          elemType +
          '>';
      }
    }
    this.cdb.markForCheck();
    return toReturn;
  }

  stripScripts(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    var scripts = div.getElementsByTagName('script');
    var i = scripts.length;
    while (i--) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }

    return div.innerHTML;
  }

  ngOnInit() {}
}
